// extracted by mini-css-extract-plugin
export var alertIcon = "_um-0";